import { render, staticRenderFns } from "./CheckboxValues.vue?vue&type=template&id=ca925146"
import script from "./CheckboxValues.vue?vue&type=script&lang=js"
export * from "./CheckboxValues.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports